import React, { FunctionComponent } from "react";
import { ButtonProps } from "./ButtonShared";

const ButtonFlatDanger = React.forwardRef(
    (
        {
            Base,
            className,
            ...props
        }: {
            Base: FunctionComponent<
                ButtonProps & {
                    buttonClassName?: string;
                    textClassName?: string;
                    iconClassName?: string;
                } & React.ButtonHTMLAttributes<HTMLButtonElement>
            >;
        } & ButtonProps &
            React.ButtonHTMLAttributes<HTMLButtonElement> &
            React.RefAttributes<HTMLButtonElement>,
        forwardedRef: React.Ref<HTMLButtonElement>
    ) => {
        return (
            <Base
                ref={forwardedRef}
                className={`bg-danger hover:bg-danger_secondary active:bg-danger_tertiary ${className}`}
                textClassName="text-white"
                iconClassName="text-white"
                {...props}
            />
        );
    }
);

export default ButtonFlatDanger;
